import { getArticles, getRedirect, searchArticles } from "./../../api";

import ActionSection from "./ActionSection";
import { Component } from "preact";
import PGDocumentIcon from "../../assets/icons/PGDocumentIcon";
import PGExternalLink from "../../assets/icons/PGExternalLink";
import PGSearchIcon from "../../assets/icons/PGSearchIcon.js";
import { debounce } from "../../utils/debounce";
import layoutStyle from "./../App/layout.scss";
import { listBoxHandler } from "../../utils/eventHandlers";
import style from "./index.scss";

const ArticleItem = ({ title, url, children, payload, onKeyPress }) => {
  if (children && children.length)
    return (
      <li
        className={style.articleItem}
        onKeyPress={(e) => {
          if (e && e.keyCode === 13) {
            // Enter
            onKeyPress && onKeyPress();
          }
        }}
      >
        {children}
      </li>
    );
  return (
    <li
      className={style.articleItem}
      onKeyPress={(e) => {
        if (e && e.keyCode === 13) {
          // Enter
          getRedirect({
            queryStr: url,
            payload: payload,
          });
        }
      }}
    >
      <div className={style.titleContainer}>
        <PGDocumentIcon />
        <a
          onClick={() =>
            getRedirect({
              queryStr: url,
              payload: payload,
            })
          }
          aria-label={title}
          className={style.title}
        >
          {title}
        </a>
      </div>
    </li>
  );
};

export default class SearchHelpCenter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: "",
      articles: [],
      initialArticles: [],
      searchCount: 0,
      isLoading: false,
      showMore: false,
      showActions: false,
    };
    this.listBoxCleanup = null;
  }

  componentDidMount() {
    this.getAndSetInitialArticles();
    this.listBoxCleanup = listBoxHandler("article-list");
  }

  componentDidUpdate() {
    if (this.listBoxCleanup) this.listBoxCleanup();
    this.listBoxCleanup = listBoxHandler("article-list");
  }

  componentWillUnmount() {
    if (this.listBoxCleanup) this.listBoxCleanup();
  }

  getAndSetInitialArticles = () => {
    const { initialArticles } = this.state;
    if (initialArticles.length) {
      this.setState({ articles: initialArticles });
      return;
    }
    this.setLoading(true);
    getArticles({ payload: this.props.payload }).then((res) => {
      const { articles = [], count } = res;
      this.setLoading(false);
      this.setState({
        initialArticles: articles,
        articles: articles,
        showMore: count > 7,
      });
    });
  };

  searchAPICall = (searchText) => {
    this.setLoading(true);
    searchArticles({
      searchQuery: searchText,
      perPage: 7,
      payload: this.props.payload,
    }).then(({ results, count }) => {
      this.setLoading(false);
      this.setState({
        articles: results,
        searchCount: count,
        showMore: count > 7,
      });
    });
  };

  setLoading = (state) => {
    this.setState({ isLoading: state });
  };

  search = (e) => {
    const { searchText } = this.state;
    if (!searchText || searchText === "") {
      this.getAndSetInitialArticles();
      this.setShowActions(false);
      return;
    }
    this.searchAPICall(searchText);
    this.setShowActions(true);
  };

  handleExternalSearch = () => {
    const { searchText } = this.state;
    const query = searchText && searchText !== "" ? searchText : "FAQs";
    const searchUrl = `https://support.peoplegrove.com/hc/en-us/search?query=${query}`;
    getRedirect({ queryStr: searchUrl, payload: this.props.payload });
  };

  handleKeyPress(e) {
    if (e.keyCode === 13) {
      this.search(e);
      e.preventDefault();
    }
  }

  setShowActions = (state) => {
    this.setState({
      showActions: state,
    });
  };

  updateSearchText = (e) => {
    this.setState({
      searchText: e.target.value,
    });
    const debouncedSearch = debounce(this.search, 1500);
    debouncedSearch();
    e.preventDefault();
  };

  render({ onContentClick, headerText = "" }) {
    const {
      searchText,
      articles,
      searchCount,
      isLoading,
      showMore,
      showActions,
    } = this.state;
    return (
      <div className={layoutStyle.searchHelpCenterContainer}>
        <div class={layoutStyle.searchHelpCenter}>
          {headerText ? <h4>{headerText}</h4> : null}
          <div>
            <PGSearchIcon className={style.searchIcon} />
            <input
              id="searchText"
              type="text"
              name="searchText"
              onInput={(e) => this.updateSearchText(e)}
              value={searchText}
              onKeyPress={(e) => this.handleKeyPress(e)}
              autofocus
              autocomplete="off"
              placeholder="Search Help"
            ></input>
          </div>
        </div>
        <div className={`${style.content} ${isLoading && layoutStyle.loader}`}>
          {!isLoading && (
            <h3 className={style.head}>
              {!searchText
                ? "Popular Help Articles"
                : `Search results (${searchCount})`}
            </h3>
          )}
          <div className={style.articlesContent}>
            {!isLoading && (
              <div>
                {articles && articles.length ? (
                  <ul id="article-list" className={style.articleListContainer}>
                    {articles.map(({ title, html_url: url }) => {
                      return (
                        <ArticleItem
                          title={title}
                          url={url}
                          payload={this.props.payload}
                        />
                      );
                    })}
                    {showMore && (
                      <ArticleItem
                        onKeyPress={() => this.handleExternalSearch()}
                      >
                        <a
                          aria-label="Browse More"
                          className={style.browseMore}
                          onClick={() => this.handleExternalSearch()}
                        >
                          <p>Browse all articles</p> <PGExternalLink />
                        </a>
                      </ArticleItem>
                    )}
                  </ul>
                ) : (
                  <div class={style.noSearchResults}>
                    We couldn’t find any matching articles. Please try another
                    search.
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {!isLoading && (
          <ActionSection
            searchText={searchText}
            onClickAction={onContentClick}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/SearchHelpCenter/index.js